import React from 'react';
import iconTg1 from '../icons/tg-1.svg';
import iconX1 from '../icons/x-1.svg';
import iconWeb from '../icons/website.svg';

const LaunchpadCard = ({
  chainId,
  progress,
  tokenName,
  tokenDescription,
  logoUrl,
  bannerUrl,
  funAddress,
  depositedAmount,
  devAddress,
  marketCap,
  website,
  twitter,
  telegram,
  BlockchainLogo,
}) => {
  const link = `/buy/?chain=${chainId}&address=${funAddress}`;

  return (
    <div className="rounded-xl overflow-hidden shadow-lg transition-all" style={{
      background: 'var(--card-bg)',
      border: '1px solid transparent',
      backgroundImage: 'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
      backgroundOrigin: 'border-box',
      backgroundClip: 'padding-box, border-box',
    }}>
      <a href={link}>
        {/* Banner */}
        <div className="relative h-40 overflow-hidden">
          {bannerUrl ? (
            <img
              src={bannerUrl}
              alt={tokenName}
              className="w-full h-full object-cover"
              onError={e => {
                e.target.onerror = null;
                e.target.src = '/logo.png';
              }}
            />
          ) : (
            <div className="w-full h-full" style={{ background: 'var(--section-bg)' }} />
          )}
        </div>

        <div className="p-4">
          {/* Header */}
          <div className="flex items-center gap-3 mb-3">
            <div className="flex-shrink-0">
              {logoUrl ? (
                <img
                  src={logoUrl}
                  alt={tokenName}
                  className="w-10 h-10 rounded-full object-cover"
                  onError={e => {
                    e.target.onerror = null;
                    e.target.src = '/logo.png';
                  }}
                />
              ) : (
                <div className="w-10 h-10 rounded-full" style={{ background: 'var(--section-bg)' }} />
              )}
            </div>
            <div className="min-w-0">
             <h3 className="font-bold truncate" style={{ color: 'var(--card-text-primary)' }}>
               {tokenName}
             </h3>
             <p className="text-xs truncate" style={{ color: 'var(--card-text-secondary)' }}>
               Created by: {devAddress.slice(0, 4)}...{devAddress.slice(-3)}
             </p>
           </div>
          </div>

          {/* Description */}
          <p className="text-sm mb-4 min-h-[3rem]" style={{ color: 'var(--card-text-secondary)' }}>
            {tokenDescription.length > 100
              ? `${tokenDescription.slice(0, 100)}...`
              : tokenDescription}
          </p>

          {/* Progress Bar */}
          <div className="mb-4">
            <div className="flex justify-between text-xs mb-1">
              <span style={{ color: 'var(--card-text-secondary)' }}>Progress</span>
              <span style={{ color: 'var(--card-text-primary)' }}>{Math.min(100, progress.toFixed(2))}%</span>
            </div>
            <div className="w-full h-2 rounded-full overflow-hidden" style={{ background: 'var(--progress-container-bg)' }}>
              <div
                className="h-full rounded-full"
                style={{
                  width: `${progress >= 100 ? 100 : progress}%`,
                  background: 'var(--progress-fill)'
                }}
              />
            </div>
          </div>

          {/* Social Icons */}
          {(website || twitter || telegram) && (
            // <div className="flex justify-center gap-4 mt-3">
            //   {twitter && (
            //     <a
            //       href={twitter}
            //       target="_blank"
            //       rel="noopener noreferrer"
            //       onClick={e => e.stopPropagation()}
            //     >
            //       <img
            //         src={TwitterIcon}
            //         alt="Twitter"
            //         className="w-5 h-5 text-white"
            //       style={{ filter: 'var(--icon-filter)'}}
            //       />
            //     </a>
            //   )}
            //   {telegram && (
            //     <a
            //       href={telegram}
            //       target="_blank"
            //       rel="noopener noreferrer"
            //       onClick={e => e.stopPropagation()}
            //     >
            //       <img
            //         src={TelegramIcon}
            //         alt="Telegram"
            //         className="w-5 h-5"
            //       // style={{ filter: 'var(--icon-filter)' }}
            //       />
            //     </a>
            //   )}
            //   {website && (
            //     <a
            //       href={website}
            //       target="_blank"
            //       rel="noopener noreferrer"
            //       onClick={e => e.stopPropagation()}
            //     >
            //       <img
            //         src={WebsiteIcon}
            //         alt="Website"
            //         className="w-5 h-5"
            //       // style={{ filter: 'var(--icon-filter)' }}
            //       />
            //     </a>
            //   )}
            // </div>
            <div className='flex justify-center gap-4 mt-3'>
              {twitter && (
                <a href="https://x.com/DogWifHair" target="_blank" className="p-2" rel="noreferrer">
                  <img src={iconX1} alt='' className="w-4 h-4 filter invert" />
                </a>
              )}
              {telegram && (
                <a href="https://t.me/dogwifhaircoin" target="_blank" className="p-2" rel="noreferrer">
                  <img src={iconTg1} alt='' className="w-4 h-4 filter invert" />
                </a>
              )}
              {website && (
                <a href="https://dogwifhair.fun" target="_blank" className="px-2 pt-1" rel="noreferrer">
                  <img src={iconWeb} alt='' className="w-6 h-6 filter invert" />
                </a>
              )}
            </div>
          )}
        </div>
      </a>
    </div>
  );
};

export default LaunchpadCard;
